import { Box, Pressable, Text } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

export const HeaderWrapper = Box.withConfig({
  paddingX: '$4',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
});

export const IconWrapper = Pressable.withConfig({
  position: 'absolute',
  left: '$2',
  top: 0,
});

export const SearchContainer = Box.withConfig({
  _ios: {
    zIndex: 1,
  },
  _web: {
    zIndex: 1,
  },
  flexDirection: {
    base: 'column',
    md: 'row',
  },
  paddingY: '$2',
  justifyContent: 'center',
  alignItems: 'center',
});

export const SearchBarWrapper = Box.withConfig({
  width: 'full',
  height: theme.token('height-input'),
});

export const SearchBarLabel = Text.withConfig({
  fontSize: 'md',
  fontWeight: 'bold',
  marginBottom: '$2',
});
